<template>
<div>
  <L1>
    <template slot="slot_title">
      <round @click="addFn" :bg="'var(--color-pri)'" :icon="'add'" :text="'新增使用者'"></round>
      <search :defaultValue="searchText" @input="searchText=$event" :width="'300px'"/>
      <page :style="{marginLeft: 'auto'}" :defaultValue="page" @input="page=$event"></page>
    </template>
    <T2 :rows="rows" :style="{marginInline: '23px 12px'}">
      <template slot="slot_head">
        <th :style="{textAlign:'start', width: '140px'}">員工姓名</th>
        <th :style="{textAlign:'start', width: '12em'}">使用者帳號</th>
        <th :style="{textAlign:'start', width: 'inherit'}">LINE</th>
        <th :style="{textAlign:'start', width: '8em'}">ERP編號</th>
        <th :style="{textAlign:'start', width: '120px'}">隸屬部門</th>
        <th :style="{textAlign:'start', width: '120px'}">職位</th>
        <th :style="{textAlign:'start', width: '140px'}">權限</th>
        <th :style="{textAlign:'center', width: '100px'}">打卡</th>
        <th :style="{textAlign:'start', width: '200px'}">更新時間</th>
        <th :style="{textAlign:'start', width: '80px'}">LINK</th>
        <th :style="{textAlign:'start', width: '80px'}">編輯</th>
        <th :style="{textAlign:'start', width: '80px'}">刪除</th>
      </template>
      <tr slot-scope="{item:{_id, name, username, ref_uid, erpID, department, title, role, clockinout, updateTime, random, expireTime},index}"
      :style="{borderBottom: 'none', minHeight: '64px', height: '64px'}">
        <td :style="{textAlign:'start'}">{{name}}</td>
        <td :style="{textAlign:'start'}">{{username}}</td>
        <td :style="{textAlign:'start'}">{{ref_uid?.lineName}}</td>
        <td :style="{textAlign:'start'}">{{erpID}}</td>
        <td :style="{textAlign:'start'}">{{department}}</td>
        <td :style="{textAlign:'start'}">{{title}}</td>
        <td :style="{textAlign:'start'}">{{roles[role]}}</td>
        <td><button @click="update(index, _id, { clockinout: !clockinout })" class="clockinout" :class="clockinout?'actived':''"></button></td>
        <!-- <td :style="{textAlign:'start', whiteSpace: 'nowrap'}">{{moment(createTime).format('yyyy.MM.DD HH:mm')}}</td> -->
        <td :style="{textAlign:'start', whiteSpace: 'nowrap'}">{{moment(updateTime).format('yyyy.MM.DD HH:mm')}}</td>
        <td v-if="random&&moment(expireTime).isAfter(moment())" @click="copylink(random, expireTime)">
          <svg width="30" height="32" viewBox="0 0 30 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.4561 5.26736H2.10517C0.947432 5.26736 0 6.21556 0 7.37422V29.4973C0 30.6559 0.947432 31.6041 2.10517 31.6041H22.4561C23.6138 31.6041 24.5613 30.6559 24.5613 29.4973V7.37422C24.5613 6.21556 23.6138 5.26736 22.4561 5.26736ZM21.7541 28.7947H2.80717V8.07636H21.7541V28.7947Z" fill="var(--color-pri)"/>
          <path d="M5.43874 2.10686C5.43874 0.948192 6.38617 0 7.5439 0H27.8948C29.0526 0 30 0.948192 30 2.10686V24.2295C30 25.3882 29.0526 26.3363 27.8948 26.3363H27.1928V2.80943H5.43874V2.10686Z" fill="var(--color-pri)"/>
          <path d="M6.4911 14.0463C6.4911 13.4667 6.96482 12.9931 7.5439 12.9931H17.0174C17.5964 12.9931 18.0697 13.4672 18.0697 14.0463V14.7484C18.0697 15.328 17.596 15.8021 17.0174 15.8021H7.5439C6.96482 15.8021 6.4911 15.328 6.4911 14.7484V14.0463ZM6.4911 20.8941C6.4911 20.3146 6.96482 19.8405 7.5439 19.8405H13.8598C14.4389 19.8405 14.9122 20.3146 14.9122 20.8941V21.5963C14.9122 22.1758 14.4385 22.6495 13.8598 22.6495H7.5439C6.96482 22.6495 6.4911 22.1754 6.4911 21.5963V20.8941Z" fill="var(--color-pri)"/>
          </svg>
        </td>
        <td @click="getRandom(index, _id)" v-else>
          <svg  width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M27.3607 6.78184C24.619 2.5459 19.9142 -0.0076016 14.8681 1.70003e-05C6.6701 1.70003e-05 0 6.64978 0 14.8228C0 22.9959 6.6701 29.6457 14.8681 29.6457C22.7291 29.6529 29.2354 23.5368 29.7113 15.6918C29.7532 14.9642 29.1973 14.3408 28.4695 14.2989C27.7422 14.2569 27.1182 14.8127 27.0762 15.5398C26.7109 21.7236 21.7664 26.6507 15.5798 26.9952C9.3936 27.3398 3.93178 22.9921 2.88142 16.8875C1.83147 10.7829 5.5266 4.8611 11.4727 3.11983C17.4189 1.37856 23.7262 4.3714 26.1368 10.0781C26.1381 10.0811 26.1402 10.0841 26.1415 10.087H19.7948C19.3211 10.0815 18.8812 10.3313 18.6428 10.7405C18.4045 11.1498 18.4045 11.6556 18.6428 12.0649C18.8812 12.4742 19.3215 12.7239 19.7948 12.7184H27.9323C29.072 12.7188 29.997 11.7966 30 10.6572V2.63224C30 1.9034 29.409 1.31296 28.6804 1.31296C27.9513 1.31296 27.3607 1.90382 27.3607 2.63224V6.78184Z" fill="var(--color-pri)"/>
          <path d="M20.211 21.2537C19.8858 21.2537 19.5611 21.1296 19.313 20.8816L14.786 16.3558C14.1116 15.6815 13.7403 14.7851 13.7403 13.8315V6.38851C13.7403 5.68718 14.3088 5.11874 15.0104 5.11874C15.7119 5.11874 16.2804 5.68718 16.2804 6.38851V13.8315C16.2804 14.1066 16.3876 14.3652 16.5823 14.5599L21.1093 19.0857C21.6055 19.5818 21.6055 20.3856 21.1093 20.8816C20.8612 21.1296 20.5361 21.2537 20.211 21.2537Z" fill="var(--color-pri)"/>
          </svg>
        </td>
        <td><edit @click="editFn(index)" :style="{backgroundColor: 'var(--color-checked)', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)'}"></edit></td>
        <td><Del :style="{width: '36px'}" @click="deleteItem(index, _id, name)"></Del></td>
      </tr>
    </T2>
    <div id="pop" v-if="Link">{{Link}}</div>
    <div id="poperror" v-if="LinkError">{{LinkError}}</div>
  </L1>
  <AddNewVue @close="add=false" @new="rows.splice(0, 0, $event);add=false" :rolemap="rolemap" v-if="add"></AddNewVue>
  <EditVue @close="selected=null" @updateItem="updateItem" :selected="selected" v-if="selected"  :rolemap="rolemap"></EditVue>
  <DialogDef2 :width="670" :show="alertshow" @close="alertshow=null" label="提醒" :haadBg="'var(--color-pri)'">
    <div class="alarm">網址已複製!<br>
          請將設置網址提供給您的夥伴設定帳號</div>
    <ul>
      <li>設置網址僅限發行對象使用</li>
      <li>設置網址僅限使用一次</li>
      <li>需於30分鐘內完成設置(本次使用期限: {{moment(alertshow).format('MM/DD HH:mm')}} )</li>
    </ul>
  </DialogDef2><DialogDef2 :width="670" :show="alertshow2" @close="alertshow2=null" label="提醒" :haadBg="'var(--color-pri)'">
    <div class="alarm">權限不足!<br>
        您沒有{{alertshow2}}員工資訊的權限</div>
    <ul>
      <li>{{alertshow2}}員工資訊情洽主管或管理員</li>
    </ul>
  </DialogDef2>
</div>
</template>

<script>
import { getapi, postapi, deleteapi } from '../../store/fetch'
import { mapState } from 'vuex'
import Round from '../../components/btn/round.vue'
import Page from '../../components/input/page.vue'
import Search from '../../components/input/search.vue'
import L1 from '../../components/layout/L1.vue'
import T2 from '../../components/tables/t2.vue'
import Del from '../../components/btn/del.vue'
import Edit from '../../components/btn/edit.vue'
import EditVue from './edit.vue'
import AddNewVue from './add.vue'
export default {
  components: { L1, Round, Search, T2, Page, Del, Edit, AddNewVue, EditVue },
  data () {
    return {
      add: false,
      searchText: null,
      rows: [],
      page: 1,
      limit: 15,
      Link: null,
      LinkError: null,
      selected: null,
      alertshow: null,
      alertshow2: false
    }
  },
  computed: {
    ...mapState({
      rolemapX: 'rolemap'
    }),
    rolemap () {
      const inner = this.rolemapX.filter(e => e.type === 'inner')
      if (this.myRole === 'admin') {
        return inner
      }
      return inner.filter(e => (this.roleLevel(e.key) < this.roleLevel(this.myRole)))
    },
    rolemap0 () {
      const inner = this.rolemapX.filter(e => e.type === 'inner')
      return inner
    },
    roles () {
      return Object.assign({}, ...this.rolemap0.map(e => { return { [e.key]: e.zh } }))
    },
    myRole () {
      return this.$store.getters.myRole
      // return 'manager'
    }
  },
  watch: {
    page () {
      this.getusers()
    },
    searchText () {
      this.page = 1
      this.getusers()
    }
  },
  async mounted () {
    await this.getusers()
  },
  methods: {
    roleLevel (role) {
      switch (role) {
        case 'employee':
          return 1
        case 'manager':
          return 10
        case 'admin':
          return 100
        default:
          return 0
      }
    },
    addFn () {
      if (this.myRole === 'manager' || this.myRole === 'admin') {
        this.add = true
      } else {
        this.alertshow2 = '新增'
      }
    },
    editFn (index) {
      if (this.myRole === 'manager' || this.myRole === 'admin') {
        this.selected = this.rows[index]
      } else {
        this.alertshow2 = '編輯'
      }
    },
    async deleteItem (index, id, name) {
      if (this.roleLevel(this.myRole) > this.roleLevel(this.rows[index].role)) {
        if (confirm(`確定要刪除[${name}]帳號嗎?`)) {
          const r = await deleteapi(`users/${id}`)
          if (r) {
            this.rows.splice(index, 1)
          }
        }
      } else {
        this.alertshow2 = '刪除'
      }
    },
    async update (index, id, value) {
      const r = await postapi(`users/local/${id}`, value)
      if (r) {
        this.rows.splice(index, 1, r)
      }
    },
    async getRandom (index, id) {
      const r = await postapi(`users/random/${id}`)
      if (r) {
        this.rows.splice(index, 1, r)
      }
    },
    addnew (data) {
      this.rows.unshift(data)
      this.addEmp = false
    },
    async copylink (LINK, expireTime) {
      const link = `${window.location.origin}${window.location.pathname.replace('/EmployeeSetting', '')}#/signup/${LINK}`
      try {
        const x = await this.$copyText(link)
        if (x) {
          this.Link = '複製成功'
          this.alertshow = expireTime
          setTimeout(() => {
            this.Link = null
          }, 2000)
          setTimeout(() => {
            this.alertshow = null
          }, 5000)
        }
      } catch (error) {
        this.LinkError = '複製失敗'
        setTimeout(() => {
          this.LinkError = null
        }, 2000)
      }
    },
    async updateValue (id, value) {
      const r = await postapi(`users/local/${id}`, value)
      if (r) {
        this.updateItem(r)
      }
    },
    updateItem (ev) {
      const index = this.rows.map(e => e._id).indexOf(ev._id)
      this.rows.splice(index, 1, ev)
      this.selected = null
    },
    async getusers () {
      const params = { page: this.page, limit: this.limit }
      if (this.searchText) {
        params.search = this.searchText
      }
      const users = await getapi(`users/local?${new URLSearchParams(params)}`)
      this.rows = users.data
      this.count = users.count
    }
  }

}
</script>

<style lang="scss" scoped>
.alarm {
  font-style: normal;
font-weight: 700;
font-size: 24px;
line-height: 150%;
text-align: center;
letter-spacing: 0.1em;
color: #FF8B8B;
margin-block: 35px 21px;

}
ul {
  width: fit-content;
  margin-inline: auto;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 200%;
  letter-spacing: 0.05em;
  color: #8C8C8C;
  margin-bottom: 47px;
}
li {
  text-align: start;
}
td {
  letter-spacing: 0!important;
}
.clockinout {
  margin: auto;
  background-color: #e5e5e5;
  width: 35px;
  height: 35px;
  padding-inline: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  &.actived {
    background-color: var(--color-pri);
  }
  &::before {
    content: "";
    width: 25px;
    height: 25px;
    display: inline-block;
    mask-size: 23px;
    mask-position: center;
    mask-repeat: no-repeat;
    background-color: #FFFFFF;
    mask-image: url(../svg/status/clockin.svg);
  }
}
#pop {
  position: fixed;
  bottom: 20px;
  right: 20px;
  height: 60px;
  border-radius: 3px;
  background-color: var(--color-bar);
  color: var(--color-pri);
  display: flex;
  align-items: center;
  justify-content: center;
  padding-inline: 20px;
  box-shadow: 2px 1px 2px rgba(0, 0, 0, 0.25);
}
#poperror {
  position: fixed;
  bottom: 20px;
  right: 20px;
  height: 60px;
  border-radius: 3px;
  background-color: var(--color-bar);
  color: var(--highlight);
  display: flex;
  align-items: center;
  justify-content: center;
  padding-inline: 20px;
  box-shadow: 2px 1px 2px rgba(0, 0, 0, 0.25);
}
</style>
